import React, {useEffect, useMemo, useState} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import {useDispatch} from "react-redux";
import {store} from "react-notifications-component";
import client from "../../lib/api/client";
import {withRouter} from "react-router-dom";
import {styled} from "@material-ui/core";
import {useRecoilState, useSetRecoilState} from "recoil";
import {openDateState, userState} from "../../state/globalState";
import {AESEncrypt} from "../../utils/aes";

function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center" style={{color: 'white', margin: '20px 0'}}>
            {'Copyright © '}
            <Link color="inherit" href="https://material-ui.com/">
                EY
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

const useStyles = makeStyles(theme => ({
    '@global': {
        body: {
            backgroundColor: theme.palette.common.white,
            height: '100%',
        },
    },
    container: {
        marginTop: '40px',
        width: '100%',
        height: '100%',
        animation: `$smoothAppear 2000ms ${theme.transitions.easing.easeInOut}`,
        position: 'relative',
    },
    paper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        position: 'relative',
        zIndex: 1,
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: '#3686b0',
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
    "@keyframes smoothAppear": {
        "from": {
            opacity: 0,
            transform: "translateY(30%)"
        },
        "to": {
            opacity: 1,
            transform: "translateY(0)"
        }
    },

  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(49,48,48,0.39)',
    pointerEvents: 'none',
    zIndex: 0,
  },
}));

const AuthForm = ({ stdYear, setStep, history }) => {
    const setUserInfo = useSetRecoilState(userState);
    const [openDate, setOpenDate] = useRecoilState(openDateState);
    const [corprCode, setCorprCode] = useState("");
    const [userId, setUserId] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isErrorCorprCode, setIsErrorCorprCode] = useState(false);
    const [errorMsgCorprCode, setErrorMsgCorprCode] = useState("");
    const [isErrorUserId, setIsErrorUserId] = useState(false);
    const [errorMsgUserId, setErrorMsgUserId] = useState("");
    const [isErrorPassword, setIsErrorPassword] = useState(false);
    const [errorMsgPassword, setErrorMsgPassword] = useState("");

    const dispatch = useDispatch();
    const classes = useStyles();

    useEffect(() => {
        if (errorMessage) {
            store.addNotification({
                title: "알림",
                message: errorMessage,
                type: 'warning',
                insert: "top",
                container: "top-center",
                animationIn: ["animated", "flipInY"],
                animationOut: ["animated", "flipOutY"],
                dismiss: {
                    duration: 5000,
                    onScreen: false
                },
                width: 500
            });
        }
    }, [errorMessage])

    const onChange = e => {
        const { value, name } = e.target;
        // const clean = sanitizeHtml(value, {
        //     allowedTags: [],
        //     allowedAttributes: []
        // });
        if (name === "corprCode") {
            if (value.length <= 8) {
                setCorprCode(value);
                setIsErrorCorprCode(false);
                setErrorMsgCorprCode("");

                if (name === "한영") {
                    setCorprCode("71545096");
                    setUserId("99999");
                    setPassword("1234");
                }
            }
        } else if (name === "userId") {
            if (value.length <= 50) {
                setUserId(value);
                setIsErrorUserId(false);
                setErrorMsgUserId("");
            }
        } else if (name === "password") {
            if (value.length <= 20) {
                setPassword(value);
                setIsErrorPassword(false);
                setErrorMsgPassword("");
            }
        }
    };

    const onSubmit = e => {
        e.preventDefault();

        const yearRegex = /\d{4}$/;
        const yearValid = yearRegex.test(stdYear);
        if (!yearValid) {
            store.addNotification({
                title: "알림",
                message: "잘못된 URL로 접근하였습니다. 관리자에게 문의 바랍니다.",
                type: 'warning',
                insert: "top",
                container: "top-center",
                animationIn: ["animated", "flipInY"],
                animationOut: ["animated", "flipOutY"],
                dismiss: {
                    duration: 3000,
                    onScreen: false
                },
                width: 500
            });
            return;
        }

        if (corprCode === "") {
            setIsErrorCorprCode(true);
            setErrorMsgCorprCode("법인번호를 입력하세요.");
        }

        if (userId === "") {
            setIsErrorUserId(true);
            setErrorMsgUserId("이메일을 입력하세요.");
        }

        if (password === "") {
            setIsErrorPassword(true);
            setErrorMsgPassword("비밀번호를 입력하세요.");
        }

        if (corprCode === "" || userId === "" || password === "") {
            return false;
        }

        if (!emailCheck(userId)) {
            setIsErrorUserId(true);
            setErrorMsgUserId("올바른 이메일 형식으로 입력하세요.");
            return false;
        }

        setErrorMessage("");
        const encPassword = AESEncrypt(password);
        // const encryptedCorprCode = aes128Encode(aes128SecretKey, aes128Iv, corprCode);
        // const encryptedUserId = aes128Encode(aes128SecretKey, aes128Iv, userId);
        // const encryptedPassword = aes128Encode(aes128SecretKey, aes128Iv, password);
        client.post('/kognr/login', { stdYear, corprInfoDiviNo: corprCode, email: userId, password: encPassword }).then(response => {
            if (response.data.success) {
                const { payload } = response.data;
                const { gnrScheSttDt, gnrScheEndDt, corprInfoDiviNo, admnNo, openYn, kognrPwdInitYn, userId } = payload;


                if (openYn === "0") {
                    setOpenDate({
                        gnrScheSttDt,
                        gnrScheEndDt
                    });
                    setStep("OPEN");
                    return;
                }

                setUserInfo({
                    admnNo
                });

                // API 요청하는 콜마다 헤더에 accessToken 담아 보내도록 설정
                // client.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
                client.defaults.headers.common.Authorization = `Bearer ${payload.accessToken}`;
                localStorage.setItem('accessToken', payload.accessToken);
                localStorage.setItem('refreshToken', payload.refreshToken);
                // Cookies.set("access_token", payload.accessToken);
                if (kognrPwdInitYn === "1") {
                    setStep("CHANGE");
                } else {
                    if (payload.surveyYn === "1") {
                        history.push("/result-mail");
                    } else {
                        console.log("Move agree page");
                        history.push("/agree");
                    }
                }
            } else {
                const { code, message } = response.data.error;
                if (code === "E0002" || code === "E0004" || code === "E0005"  || code === "E0008") {
                    setIsErrorPassword(true);
                    setErrorMsgPassword(message);
                } else {
                    setIsErrorPassword(true);
                    setErrorMsgPassword("비밀번호를 입력하세요.");
                }
            }
        }).catch((res) => {
            const { error } = res;
            console.log("Error : ", res);
        });
    };

    const emailCheck = (email) => {
        const regex=/([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
        return (email !== '' && email !== 'undefined' && regex.test(email));
    }

    const LoginTextField = useMemo(() => {
        return styled(TextField)({
            '& label.MuiInputLabel-root': {
                color: 'white',
            },
            '& label.Mui-focused': {
                color: 'white',
            },
            '& .MuiInput-underline:after': {
                borderBottomColor: 'white',
            },
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: 'white',
                },
                '&:hover fieldset': {
                    borderColor: 'yellow',
                },
                '&.Mui-focused fieldset': {
                    borderColor: 'white',
                },
            },
            '& input': {
                color: 'white',
            },
        });
    }, []);

    return (
        <>
            <CssBaseline />
            <Container component="main" maxWidth="xs" className={classes.container}>
                <div className={classes.overlay} />
                <div className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5" style={{color: 'white'}}>
                        로그인
                    </Typography>
                    <form className={classes.form} noValidate onSubmit={onSubmit} autoComplete="off">
                        <LoginTextField
                            key="auth-corpr-info-divi-no"
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            size="small"
                            label="법인번호"
                            name="corprCode"
                            autoFocus
                            autoComplete="off"
                            error={isErrorCorprCode}
                            helperText={errorMsgCorprCode}
                            onChange={onChange}
                            value={corprCode}
                        />
                        <LoginTextField
                            key="auth-user-id"
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            size="small"
                            label="이메일"
                            type="email"
                            name="userId"
                            autoComplete="off"
                            error={isErrorUserId}
                            helperText={errorMsgUserId}
                            onChange={onChange}
                            value={userId}
                        />
                        <LoginTextField
                            key="auth-password"
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            size="small"
                            name="password"
                            label="비밀번호"
                            type="password"
                            autoComplete="off"
                            error={isErrorPassword}
                            helperText={errorMsgPassword}
                            onChange={onChange}
                            value={password}
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            color="primary"
                            className={classes.submit}
                        >
                            로그인
                        </Button>
                        <Box>
                            <Link href="#" style={{ color: "#ffffff"}} onClick={() => setStep("FORGOT")}>
                                비밀번호를 잊으셨나요?
                            </Link>
                        </Box>
                    </form>
                    <Box>
                        <Copyright />
                    </Box>
                </div>

            </Container>
        </>
    );
};

export default withRouter(AuthForm);

